// extracted by mini-css-extract-plugin
module.exports = {"Comments":"Comments_Comments__26YpP","PostComment":"Comments_PostComment__25W9V"};